import main from '@amo/core/assets/images/AMO_Icons/Pas-avance-argent.svg';
import locker from '@amo/core/assets/images/icons/locker.png';
import paiement from '@amo/core/assets/images/icons/paiement.png';
import opinions from '@amo/core/assets/images/logos/opinion.png';
import _ from 'lodash';
import footer_logos from "@amo/core/assets/images/footer_recommande.png";
import gilet_inmotion from '../../../../assets/images/footer/gilet_inmotion.png';
import logo_inmotion from '../../../../assets/images/footer/in&motion.png';
import logo_liberty from '../../../../assets/images/footer/liberty-rider.png';
import logo_sentidrive from '../../../../assets/images/footer/logo-sentidrive.png';
import phone_liberty from '../../../../assets/images/footer/phone_liberty.png';
import appli_mobile_sentidrive from '../../../../assets/images/footer/appli-mobile-sentidrive.png';
import { getStepBySlug } from '../../../../utils/function';
import {getTranslation} from "@amo/core/utils/index.js";
import {useId} from "react";

const StarRating = ({ score = 4.4, maxStars = 5 }) => {
    const idPrefix = useId();
    return (
        <div
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: '#F2F7F9',
                borderRadius: 8,
                padding: '8px 16px',
                gap: 8,
            }}
            role="img"
            aria-label={`Note de ${score} sur ${maxStars}`}
        >
            <span
                style={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: '#004161',
                    lineHeight: 1,
                }}
            >
                {score}/{maxStars}
            </span>
            <span style={{ display: 'inline-flex', gap: 2 }} aria-hidden="true">
                {Array.from({ length: maxStars }, (_, i) => {
                    const filled = score - i;
                    let fillPercent = 0;
                    if (filled >= 1) fillPercent = 100;
                    else if (filled > 0) fillPercent = Math.round(filled * 100);
                    return (
                        <svg
                            key={i}
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <defs>
                                <linearGradient id={`${idPrefix}-star-${i}`}>
                                    <stop offset={`${fillPercent}%`} stopColor="#FFD518" />
                                    <stop offset={`${fillPercent}%`} stopColor="#ddd" />
                                </linearGradient>
                            </defs>
                            <path
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                fill={`url(#${idPrefix}-star-${i})`}
                            />
                        </svg>
                    );
                })}
            </span>
        </div>
    );
};

const Footer = ({ gestionnaireIsAMO, step, data }) => {
    const recontactByPostalCode = _.get(data, 'recontactByPostalCode') || false;

    return (
        <>
            <div className={`footer f-13 d-lg-block ${step === getStepBySlug('votre-tarif') && 'bg-grey'}`}>
                {!recontactByPostalCode && (
                    <>
                        {gestionnaireIsAMO && (
                            <div className={'container p-5'}>
                                <div className="row">
                                    <div className={'col-12 text-center'}>
                                        <img
                                            src={main}
                                            alt=""
                                            aria-hidden="true"
                                            height={56}
                                            loading="lazy"
                                        />
                                        <h2 className={'f-24 mb-4'} dangerouslySetInnerHTML={{__html: getTranslation('footer.exclusifOffers')}} />
                                    </div>
                                    <div
                                        className="col-lg-4 col-12 d-flex align-items-center text-start mb-lg-0 mb-4 justify-content-lg-end">
                                        <img src={phone_liberty} alt="" aria-hidden="true" width={111} height={109} loading="lazy"/>
                                        <p className={'ms-1 fw-semibold text-dark'}>
                                            <img
                                                src={logo_liberty}
                                                alt=""
                                                aria-hidden="true"
                                                className={'d-block mb-lg-3 mb-2'}
                                                width={100}
                                                loading="lazy"
                                            />
                                            <span dangerouslySetInnerHTML={{__html: getTranslation('footer.liberty')}}/>
                                        </p>
                                    </div>
                                    <div
                                        className="col-lg-4 col-12 d-flex align-items-center text-start mb-lg-0 mb-4 justify-content-lg-end">
                                        <img src={appli_mobile_sentidrive} alt="" aria-hidden="true" width={100} loading="lazy"/>
                                        <p className={'ms-1 fw-semibold text-dark'}>
                                            <img
                                                src={logo_sentidrive}
                                                alt=""
                                                aria-hidden="true"
                                                className={'d-block mb-lg-3 mb-2'}
                                                width={113}
                                                loading="lazy"
                                            />
                                            {getTranslation('footer.sentydrive')}
                                        </p>
                                    </div>
                                    <div
                                        className="col-lg-4 col-12 d-flex align-items-center text-start justify-content-lg-start">
                                        <img src={gilet_inmotion} alt="" aria-hidden="true" width={100} height={101} loading="lazy"/>
                                        <p className={'ms-1 fw-semibold text-dark'}>
                                            <img
                                                src={logo_inmotion}
                                                alt=""
                                                aria-hidden="true"
                                                className={'d-block mb-lg-3 mb-2'}
                                                width={100}
                                                loading="lazy"
                                            />
                                            <span dangerouslySetInnerHTML={{__html: getTranslation('footer.inemotion')}}/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div
                            className={`container-fluid d-lg-block d-none ${
                                step === getStepBySlug('votre-tarif') ? 'bg-linear-2' : 'bg-linear'
                            }`}
                        >
                            <div className={'container'}>
                                <div className={'px-5'}>
                                    <div className={'row align-items-center'}>
                                        {gestionnaireIsAMO && (
                                            <>
                                                <div className={'col-2'}>
                                                    &nbsp;
                                                </div>
                                                <div className={'col-5'}>
                                                    <img src={footer_logos} alt={'Recommandé par Le Repaire des Motards - Partenaire de Johann Zarco - Label d\'Excellence 2025 Moto et Scooter, Les Dossiers de l\'Assurance, APRIL Moto'} loading="lazy"/>
                                                </div>
                                                <div className={'col-4 d-flex'}>
                                                    <div className={'left'}>
                                                        <StarRating score={4.4} maxStars={5} />
                                                        <p
                                                            className={'f-11 fw-semibold text-grey'}
                                                            style={{ marginLeft: 63 }}
                                                            dangerouslySetInnerHTML={{__html: getTranslation('footer.votes', {votes: "3&nbsp;728"})}}
                                                        />
                                                    </div>
                                                    <div className={'right ms-4'}>
                                                        <a
                                                            href={
                                                                'https://www.opinion-assurances.fr/assureur-april-moto.html'
                                                            }
                                                            target={'_blank'}
                                                            rel="noopener noreferrer"
                                                        >
                                                            <img
                                                                src={opinions}
                                                                alt={'Opinions Assurances'}
                                                                width={98}
                                                                height={32}
                                                                loading="lazy"
                                                            />
                                                            <span className="visually-hidden"> (nouvelle fenêtre)</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {!gestionnaireIsAMO && (
                                            <div className={'col-5'} style={{ height: 100 }}>
                                                &nbsp;
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div className={`container-fluid bg-grey d-block d-lg-none d-xl-none py-4`}>
                    <div className={'row align-items-center'}>
                        {gestionnaireIsAMO && (
                            <>
                                <div className={'col-12 text-center mb-4'}>
                                    <img src={footer_logos} alt={'Recommandé par Le Repaire des Motards - Partenaire de Johann Zarco - Label d\'Excellence 2025 Moto et Scooter, Les Dossiers de l\'Assurance, APRIL Moto'} className={'img-fluid'} loading="lazy"/>
                                </div>
                                <div className={'col-12 d-flex align-items-center justify-content-center mb-5'}>
                                    <div className={'left'}>
                                        <StarRating score={4.4} maxStars={5} />
                                        <p className={'f-11 fw-semibold text-grey'} style={{ marginLeft: 63 }}>
                                            {getTranslation('footer.votes', {votes: "3&nbsp;728"})}{' '}
                                        </p>
                                    </div>
                                    <div className={'right ms-4'}>
                                        <a
                                            href={'https://www.opinion-assurances.fr/assureur-april-moto.html'}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                        >
                                            <img src={opinions} alt={'Opinions Assurances'} width={98} height={32} loading="lazy"/>
                                            <span className="visually-hidden"> (nouvelle fenêtre)</span>
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className={'col-12 text-center mb-5'}>
                            <p className={'text-grey f-12 fw-bold'}>
                                <img src={locker} alt="" aria-hidden="true" loading="lazy"/>
                                {getTranslation('footer.securePayment')} <img src={paiement} alt="Cartes bancaires acceptées : Mastercard et Visa" width={88} height={27} loading="lazy"/>
                            </p>
                        </div>
                    </div>
                </div>
                <div className={`container-fluid p-4 f-12 bg-white`}>
                    <div className="row footer-link">
                        <nav className="col-12 text-center footer-links-underline" aria-label="Liens légaux">
                            <ul className="list-unstyled d-lg-inline-flex flex-wrap justify-content-center mb-0">
                                {gestionnaireIsAMO && (
                                    <li>
                                        <a
                                            href={'/mentions-legales/cgu.html'}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'text-grey mx-4 d-block d-lg-inline-block mb-2 mb-lg-0'}
                                        >
                                            {getTranslation('footer.legalNotices')}
                                            <span className="visually-hidden"> (version accessible, nouvelle fenêtre)</span>
                                        </a>
                                    </li>
                                )}
                                <li>
                                    <a
                                        href={
                                            gestionnaireIsAMO
                                                ? 'https://www.april-moto.com/gestion-des-cookies/'
                                                : 'https://amgestionassurance.com/gestion-cookies.html'
                                        }
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                        className={'text-grey mx-4 d-block d-lg-inline-block mb-2 mb-lg-0'}
                                    >
                                        {getTranslation('footer.cookieManagement')}
                                        <span className="visually-hidden"> (nouvelle fenêtre)</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={
                                            gestionnaireIsAMO
                                                ? '/mentions-legales/donnees-personnelles.html'
                                                : 'https://www.amgestionassurance.com/Doc/Lettre-RGPD-AM-Gestion-11.2021.pdf'
                                        }
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                        className={'text-grey mx-4 d-block d-lg-inline-block mb-2 mb-lg-0'}
                                    >
                                        {getTranslation('personalDataPolicy')}
                                        <span className="visually-hidden"> {gestionnaireIsAMO ? '(version accessible, nouvelle fenêtre)' : '(nouvelle fenêtre)'}</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={
                                            gestionnaireIsAMO
                                                ? '/mentions-legales/reclamations.html'
                                                : 'https://amgestionassurance.com/#reclamations'
                                        }
                                        target={'_blank'}
                                        rel="noopener noreferrer"
                                        className={'text-grey mx-4 d-block d-lg-inline-block mb-2 mb-lg-0'}
                                    >
                                        {getTranslation('footer.complaints')}
                                        <span className="visually-hidden"> {gestionnaireIsAMO ? '(version accessible, nouvelle fenêtre)' : '(nouvelle fenêtre)'}</span>
                                    </a>
                                </li>
                                {gestionnaireIsAMO && (
                                    <li>
                                        <a
                                            href={'/mentions-legales/fonctionnement-tarificateurs.html'}
                                            target={'_blank'}
                                            rel="noopener noreferrer"
                                            className={'text-grey mx-4 d-block d-lg-inline-block mb-2 mb-lg-0'}
                                        >
                                            {getTranslation('footer.howItsWork')}
                                            <span className="visually-hidden"> (version accessible, nouvelle fenêtre)</span>
                                        </a>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;
